import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { StorageHandler } from 'C4';
import { storageKeys } from 'settings';

export default class BackImage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      color: null,
    };
  }

  componentDidMount() {
    this.loadBgImage();
  }

  async loadBgImage() {
    const appInfo = await StorageHandler.load(storageKeys.appInfo);
    if (appInfo) {
      this.setState({
        color: appInfo.primaryColor,
      });
    }
  }

  render() {
    const { color } = this.state;
    const { blur, darken } = this.props;
    return (
      <div className="bgImage">
        {color && (
          <div
              style={{ backgroundColor: color }}
              className={`backgroundImage ${blur && 'blur'} ${
              darken && 'darken'
            }`}
          />
        )}
      </div>
    );
  }
}

BackImage.propTypes = {
  blur: PropTypes.bool,
  darken: PropTypes.bool,
};

BackImage.defaultProps = {
  blur: false,
  darken: false,
};
